import React from 'react';
import {Heading, Box, VStack, HStack, Text, View} from 'native-base';
import {BolivarIcon, DollarIcon} from '../../../../../../components/icons';
import {message} from '../../../../../../utils/messages';
import {formatMoney} from '../../../../../../utils/format';

export interface ISummarySectionProps {
  foreign: number;
  local: number;
}

const SummarySection = (props: ISummarySectionProps) => {
  const {foreign, local} = props;

  return (
    <Box paddingX={8}>
      <VStack
        flex={1}
        borderTopColor={'#D9EDFF'}
        borderTopWidth={1}
        marginTop={2}
        paddingTop={4}>
        <HStack space={5}>
          <VStack justifyContent="center" space="0" flex={1}>
            <Box height="6" justifyContent="center">
              <Heading size="sm" fontWeight="medium" color="#4C4C4C">
                {message('unpaided-invoice-fees-header-section-title')}
              </Heading>
            </Box>
          </VStack>
          <HStack w="110" justifyContent="center">
            <VStack justifyContent="center" space="1">
              <Box height="6" justifyContent="center">
                <DollarIcon />
              </Box>
              <Box height="6" justifyContent="center" marginTop={1}>
                <BolivarIcon />
              </Box>
            </VStack>
            <VStack space="1" w={'110'} justifyContent="center">
              <View
                height="6"
                alignItems="flex-end"
                paddingLeft="2"
                justifyContent="center">
                <Text fontWeight="bold" color="#06355E" fontSize="md">
                  {formatMoney(foreign, '')}
                </Text>
              </View>
              <Box
                height="6"
                alignItems="flex-end"
                paddingLeft="2"
                justifyContent="center"
                marginTop={1}>
                <Text fontWeight="bold" color="#06355E" fontSize="md">
                  {formatMoney(local, '')}
                </Text>
              </Box>
            </VStack>
          </HStack>
        </HStack>
      </VStack>
    </Box>
  );
};
export default SummarySection;
